package com.example.monetix.ui.components

import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp

@Composable
fun MonetixHeader(
    title: String = "",
    isHomeScreen: Boolean = false,
    userName: String = "Utente",
    greetingText: String = "Buongiorno,",
    textColor: Color = MaterialTheme.colorScheme.onBackground,
    actions: @Composable RowScope.() -> Unit = {} // 🚀 FIX: Questo permette di inserire qualsiasi icona o menu personalizzato a destra!
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 20.dp, vertical = 12.dp),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        // PARTE SINISTRA (Testo)
        Column(modifier = Modifier.weight(1f)) {
            if (isHomeScreen) {
                Text(
                    text = greetingText,
                    style = MaterialTheme.typography.labelMedium,
                    color = textColor.copy(alpha = 0.7f)
                )
                Text(
                    text = userName,
                    style = MaterialTheme.typography.headlineSmall.copy(fontWeight = FontWeight.Black),
                    color = textColor
                )
            } else {
                Text(
                    text = title,
                    style = MaterialTheme.typography.headlineSmall.copy(fontWeight = FontWeight.Black),
                    color = textColor
                )
            }
        }

        // PARTE DESTRA (Icone dinamiche fornite da chi usa il componente)
        Row(verticalAlignment = Alignment.CenterVertically, content = actions)
    }
}